import React, { useState } from 'react';
import { Stack, Button, Collapse, Typography, Box } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';

import CopyButton from '../../../../components/core/CopyButton';

type Props = {
  title: string;
  infoString: string;
  additionalContent?: React.ReactNode;
};

export const InfoCopy = ({ title, infoString, additionalContent }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Stack>
      <Button
        disableRipple
        startIcon={
          <ChevronRight
            sx={{
              transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s',
            }}
          />
        }
        sx={{
          width: 'fit-content',
          textTransform: 'none',

          color: 'black',
          fontWeight: 'bold',
          fontSize: '16px',
          p: 0,
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
      </Button>
      <Collapse in={isOpen}>
        <Box sx={{ pl: 2 }}>
          <Stack spacing={1} direction="row" sx={{ alignItems: 'center' }}>
            <Typography
              sx={{
                fontSize: '14px',
                color: 'grey.900',
                overflowWrap: 'anywhere',
              }}
            >
              {infoString}
            </Typography>
            <CopyButton title={title} copyString={infoString} />
          </Stack>
          {additionalContent}
        </Box>
      </Collapse>
    </Stack>
  );
};
